"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIterableFromEmitter = void 0;
function getIterableFromEmitter(emitter, options) {
    return require('for-emit-of')(emitter, { ...options, keepAlive: 1000 });
}
exports.getIterableFromEmitter = getIterableFromEmitter;
